@if (
    {
        requestType: requestType$ | async,
        travelCardVM: travelCardVM$ | async,
        isUpdate: isUpdate$ | async,
    };
    as vm
) {
    <form [formGroup]="requestFormGroup" appScrollToInvalidControlOnSubmit class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item third stepper-min-width">
                <div class="sidebar">
                    <medpace-vertical-stepper [steps]="steps"></medpace-vertical-stepper>
                    <div class="sidebar-container" id="request-history">
                        @if (elevatedAccess) {
                            <div class="request-patient-note-container">
                                @if (request?.id) {
                                    <medpace-request-side-notes
                                        [notes]="requestNotes()"
                                        [objectId]="request?.id"
                                        [context]="getRequestNoteCardContext(vm.requestType)"
                                    ></medpace-request-side-notes>
                                }
                                @if (patientNotes().length > 0) {
                                    <medpace-request-side-notes
                                        [notes]="patientNotes()"
                                        [objectId]="patientId$ | async"
                                        [context]="NoteCardContext.Patient"
                                    ></medpace-request-side-notes>
                                }
                                @if (siteNotes().length > 0) {
                                    <medpace-request-side-notes
                                        [notes]="siteNotes()"
                                        [objectId]="siteId$ | async"
                                        [context]="NoteCardContext.Site"
                                    ></medpace-request-side-notes>
                                }
                            </div>
                        }
                        @if (request?.id && request?.type && request?.paymentType) {
                            <div class="request-history-container">
                                <medpace-request-history />
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="o-grid">
                    <ng-container *ngTemplateOutlet="requestbuttons"></ng-container>
                    <div class="requiredText">
                        <span class="required-asterisk">*</span>
                        <span class="note">indicates a required field</span>
                    </div>
                    @if (request) {
                        <div class="o-grid__row" id="requestType" #requestType>
                            @if (
                                elevatedAccess ||
                                request.status.statusId === GenericRequestStatus.Draft ||
                                request.status.statusId === GenericRequestStatus.ERSubmitted
                            ) {
                                <div class="o-grid__card">
                                    <medpace-input-card
                                        (incrementalUpdate)="submitIncrementalSave(true)"
                                        (inputChangeEvent)="fieldChangeEvent($event)"
                                        [editMode]="!isUpdate"
                                        [showEditSaveButton]="false"
                                        [elevatedAccess]="elevatedAccess"
                                        [parentFormGroup]="requestFormGroup"
                                        [isUpdate]="isUpdate"
                                        title="Request Information"
                                        type="request-type"
                                    ></medpace-input-card>
                                </div>
                            }
                            @if (
                                !elevatedAccess &&
                                request.status.statusId !== GenericRequestStatus.Draft &&
                                request.status.statusId !== GenericRequestStatus.ERSubmitted
                            ) {
                                <div class="o-grid__card">
                                    <medpace-input-card
                                        (incrementalUpdate)="submitIncrementalSave(true)"
                                        (inputChangeEvent)="fieldChangeEvent($event)"
                                        [editMode]="!isUpdate"
                                        [showEditSaveButton]="
                                            !isRequestStatus(3) &&
                                            isUpdateAndElevatedAccess() &&
                                            isPossibleToEditRequest()
                                        "
                                        [additionalContent]="request.status"
                                        [inputObj]="request.type"
                                        [elevatedAccess]="elevatedAccess"
                                        [paymentEnabled]="paymentAvailable"
                                        [travelEnabled]="travelAvailable"
                                        [patient]="patient"
                                        [visitDetails]="request.visitDetails"
                                        [request]="request"
                                        [parentFormGroup]="requestFormGroup"
                                        [isUpdate]="isUpdate"
                                        title="Request Information"
                                        type="request-type"
                                    ></medpace-input-card>
                                </div>
                            }
                        </div>
                    }
                    <div class="o-grid__row" id="studyInformation" #studyInformation>
                        <div class="o-grid__card">
                            <medpace-input-card
                                (inputChangeEvent)="fieldChangeEvent($event)"
                                [editMode]="false"
                                [showEditSaveButton]="false"
                                title="Study Details"
                                type="study-detail"
                            >
                            </medpace-input-card>
                        </div>
                    </div>
                    <div class="o-grid__row" id="patientInformation" #patientInformation>
                        <div class="o-grid__card">
                            <medpace-request-personal-info-card
                                [patientId]="request?.patientId"
                                [id]="'personal-info-card'"
                                [studyId]="study?.id"
                            />
                        </div>
                    </div>
                    @if (vm.requestType) {
                        <div class="o-grid__row" id="visitDetails">
                            <div class="o-grid__card">
                                @if (!isUpdate) {
                                    <medpace-create-request-visit-details
                                        [viewModel]="createRequestVisitDetails_ViewModel$ | async"
                                    ></medpace-create-request-visit-details>
                                }
                                @if (isUpdate) {
                                    <medpace-edit-request-visit-details
                                        [viewModel]="editRequestVisitDetails_ViewModel$ | async"
                                        (saveEvent)="onEditVisitDetailsSave($event)"
                                        [showSwitchModeButton]="
                                            showSwitchModeButtonInVisitDetailsCard() && isPossibleToEditRequest()
                                        "
                                    ></medpace-edit-request-visit-details>
                                }
                            </div>
                        </div>
                    }
                    <div>
                        @if (showTravelCards) {
                            <div class="o-grid__row" id="travel-information-step">
                                <div class="o-grid__card">
                                    <medpace-travel-request-card
                                        [isLoading]="!vm.travelCardVM"
                                        [formGroup]="requestFormGroup.controls.travelCard"
                                        [isUpdate]="!!vm.travelCardVM?.isUpdate"
                                        [mode]="'view'"
                                        [showBookButton]="
                                            showBookButton(vm.travelCardVM?.patientBookable, request?.status.statusId)
                                        "
                                        [showSwitchModeButton]="travelCardEditable$ | async"
                                        [request]="request"
                                        (saveEvent)="travelCardSave($event)"
                                        (bookViaGetThereForCaregiver)="bookViaGetThereForCaregiver($event)"
                                        (bookViaGetThereForPatient)="bookViaGetThereForPatient()"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                    @if (vm.requestType === 'payment') {
                        <div class="o-grid__row" id="paymentInformation">
                            <div class="o-grid__card">
                                <medpace-payment-request-card
                                    [showEditSaveButton]="isUpdate && isPossibleToEditRequest()"
                                    [reimbursementRequest]="reimbursementRequest$ | async"
                                    [stipendRequest]="stipendRequest$ | async"
                                    [formGrp]="requestFormGroup.controls.paymentCard"
                                    [mode]="isUpdate ? 'view' : 'edit'"
                                    (saveEvent)="onPaymentRequestExpenseDetailsSave($event)"
                                />
                            </div>
                        </div>
                    }
                    <ng-container *ngTemplateOutlet="requestbuttons"></ng-container>
                </div>
            </div>
        </div>
    </form>
}

<ng-template #requestbuttons>
    <div class="o-grid__row">
        @if (request) {
            <ng-container *ngTemplateOutlet="potentialDuplicate"></ng-container>
            <div class="o-grid__card">
                <div class="flex flex-row end gap-medpace">
                    @if (isDeleteButtonVisible()) {
                        <mds-button
                            (click)="deleteRequest()"
                            [id]="'delete-request-btn'"
                            label="Delete request"
                            [variant]="'tonal'"
                            color="warn"
                        >
                        </mds-button>
                    }
                    @if (isViewHistoryButtonVisible()) {
                        <mds-button
                            (click)="viewHistory()"
                            [id]="'view-history-btn'"
                            label="View history"
                            color="primary"
                            [variant]="'tonal'"
                        >
                        </mds-button>
                    }
                    @if (isSubmitButtonVisible()) {
                        <mds-button
                            (click)="submitRequest()"
                            [color]="'primary'"
                            [variant]="'filled'"
                            label="Submit"
                            [id]="'submitRequest'"
                            [disabled]="!isButtonSubmitActive()"
                            type="submit"
                        ></mds-button>
                    }
                    @if (isSaveDraftButtonVisible()) {
                        <mds-button
                            type="submit"
                            (click)="saveDraftClick()"
                            color="primary"
                            [variant]="'tonal'"
                            [id]="'saveRequestDraft'"
                            label="Save draft"
                        ></mds-button>
                    }
                    @if (isChangeStatusButtonVisible()) {
                        <mds-button
                            (click)="changeStatus()"
                            [id]="'ChangeStatusRequestBtn'"
                            label="Change status"
                            color="primary"
                            [variant]="'tonal'"
                            [disabled]="isChangeStatusButtonDisable()"
                            [matTooltip]="changeStatusButtonTooltip()"
                        >
                        </mds-button>
                    }
                    @if (isUpdateButtonVisible() && isPossibleToEditRequest()) {
                        <mds-button
                            (click)="saveDraftClick()"
                            [color]="'primary'"
                            [variant]="'filled'"
                            [id]="'updateBtn'"
                            label="Update"
                            type="submit"
                        >
                        </mds-button>
                    }
                </div>
            </div>
        }
    </div>
</ng-template>
<ng-template #potentialDuplicate>
    <div class="o-grid__card half u-ta-left">
        <div class="flex justify-start">
            <h5 class="processingText">{{ actualStatus }}</h5>
            @if (request && request.flaggedDuplicate) {
                <mat-icon class="duplicateIcon" title="Potential Duplicate"
                    ><img
                        alt="Potential Duplicate"
                        class="duplicate-red-icon"
                        src="../../../assets/img/duplicate-icn.png"
                    />
                </mat-icon>
            }
        </div>
    </div>
</ng-template>
